import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Quality Ranges Listing")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'ive'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            loading: _ctx.loading,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-titleEn": _withCtx(({ row: qualityRange }) => [
              _createTextVNode(_toDisplayString(qualityRange.titleEn), 1)
            ]),
            "cell-titleAr": _withCtx(({ row: qualityRange }) => [
              _createTextVNode(_toDisplayString(qualityRange.titleAr), 1)
            ]),
            "cell-from": _withCtx(({ row: qualityRange }) => [
              _createTextVNode(_toDisplayString(qualityRange.from), 1)
            ]),
            "cell-to": _withCtx(({ row: qualityRange }) => [
              _createTextVNode(_toDisplayString(qualityRange.to), 1)
            ]),
            "cell-createdAt": _withCtx(({ row: qualityRange }) => [
              _createTextVNode(_toDisplayString(qualityRange.createdAt), 1)
            ]),
            "cell-actions": _withCtx(({ row: qualityRange }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editQualityRange(qualityRange.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "total", "loading", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}